import React from "react";
import { ensure, GridColumn, GridRow, LabeledText, Stack } from "sprint-common-web";

import { ContentSubtype } from "../../../../../common/types/ContentSubtype";
import { ensureMovieContentSubtype } from "../../../../../common/types/MovieContentSubtype";
import { FileRecordDetails } from "../../FileRecordDetails";
import { FileRecordMovieVersionInfo } from "./FileRecordMovieVersionInfo";

interface FileRecordMovieContentViewProps {
    fileRecordDetails: FileRecordDetails;
}

export const FileRecordMovieContentView = ({ fileRecordDetails }: FileRecordMovieContentViewProps): JSX.Element => {
    ensure(fileRecordDetails.content);
    ensureMovieContentSubtype(fileRecordDetails.content.contentSubtype);

    return (
        <Stack>
            <GridRow>
                <GridColumn sm={6}>
                    <LabeledText
                        label="Title"
                        value={fileRecordDetails.content.movie.name}
                        testId="movie-name-field"
                        textTooltip
                    />
                    <LabeledText
                        label="Content type"
                        value={ContentSubtype[fileRecordDetails.content.contentSubtype]}
                        testId="movie-content-type-field"
                    />
                </GridColumn>

                <GridColumn sm={6}>
                    <FileRecordMovieVersionInfo
                        movieId={fileRecordDetails.content.movie.id}
                        versionIds={fileRecordDetails.content.versions.map((v) => v.id)}
                    />
                </GridColumn>
            </GridRow>
        </Stack>
    );
};
